import React from 'react';
import StudentList from './StudentList';

const StaffPanel = () => {
  return (
    <>
      <h1>Students</h1>
      <StudentList />
    </>
  );
};

export default StaffPanel;
